module.exports = __webpack_public_path__ + "img/parachute.d47f2cc6.webp";